import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function OAuthCallbackPage() {
  const { setTokenAndRefresh } = useAuth()
  const navigate = useNavigate()
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true

    const params = new URLSearchParams(window.location.hash.slice(1))
    const token = params.get('token')

    if (!token) {
      navigate('/?error=missing_token', { replace: true })
      return
    }

    setTokenAndRefresh(token).then(() => {
      window.history.replaceState(null, '', '/trade_applications')
      navigate('/trade_applications', { replace: true })
    })
  }, [navigate, setTokenAndRefresh])

  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center">
      <div className="card p-8">
        <div className="inline-block w-6 h-6 border-2 border-brand-500 border-t-transparent rounded-full animate-spin mb-3" />
        <p className="text-slate-700">Signing you in…</p>
      </div>
    </div>
  )
}
